/**
 * Normalize a string to a URL-safe ASCII slug (single path segment).
 *
 * Rules:
 * - Lowercase
 * - Best-effort transliteration of accents/diacritics (e.g., "Corrêa" -> "correa")
 * - Replace spaces/underscores with "-"
 * - Remove other special characters (keep only a-z, 0-9, and "-")
 * - Collapse multiple "-"
 * - Trim leading/trailing "-"
 *
 * Empty/undefined stays empty.
 */
export function normalizeUrlSlug(value) {
  if (value == null) return "";
  let s = String(value).trim();
  if (!s) return "";

  // Best-effort transliteration (match Django slugify behavior more closely).
  // If `normalize` isn't available, we fall back to the raw string (accents may be dropped later).
  try {
    s = s.normalize("NFKD");
  } catch {
    // ignore
  }

  // Strip combining marks so we keep the base character (e.g., "ê" -> "e" + combining mark -> "e").
  s = s.replace(
    /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\uFE20-\uFE2F]/g,
    ""
  );

  s = s.toLowerCase();

  // Common non-diacritic latin letters that may not decompose cleanly everywhere.
  s = s
    .replace(/ß/g, "ss")
    .replace(/æ/g, "ae")
    .replace(/œ/g, "oe")
    .replace(/ø/g, "o")
    .replace(/đ/g, "d")
    .replace(/ð/g, "d")
    .replace(/þ/g, "th")
    .replace(/ł/g, "l");

  // Replace whitespace / underscores with hyphen
  s = s.replace(/[\s_]+/g, "-");

  // Remove everything except a-z, 0-9, and hyphen
  s = s.replace(/[^a-z0-9-]/g, "");

  // Collapse hyphen runs and trim
  s = s.replace(/-+/g, "-").replace(/^-+|-+$/g, "");

  return s;
}

/**
 * Normalize a WebsitePage subdomain to a URL-safe slug.
 *
 * Kept for backwards-compatibility with existing imports.
 * Empty/undefined stays empty (main page).
 */
export function normalizeSubdomain(value) {
  return normalizeUrlSlug(value);
}
